import React from 'react';
import PropTypes from 'prop-types';
import dateFormatService from '../services/DateFormatService';

const FormattedDateTime = ({ value }) => {
  const stringValue = value instanceof Date ? value.toISOString() : value;

  return <span>{dateFormatService.formatDateWithTime(stringValue)}</span>;
};

FormattedDateTime.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
};

export default FormattedDateTime;
